// 米家国内的语言: 简体中文/繁体中文/英文/藏语/维吾尔语
export const H5_LOCALE_REG_DOMESTIC = {
  zh_tw: /^zh_(hk|tw|hans)/i, // 繁体中文
  zh_cn: /^zh/,               // 简体中文
  en: /^en/i,                 // 英文
  bo_cn: /^bo_CN/i,           // 藏语
  ug_cn: /^ug_CN/i,           // 维吾尔语
}
